import React from 'react';
import { Waypoint } from 'react-waypoint';
import styled, { css } from 'styled-components';
import { trackEvent } from '@99designs/tracking';
import Box from '../../../shared/spa/core-components/Box';
import { BoxProps } from '../../../shared/spa/core-components/Box/Box';

interface PageSectionProps extends BoxProps {
    children: React.ReactNode;
    id: string;
    pageName: string;
    backgroundGradientColors?: [string, string];
    onEnter?: (id: string) => void;
}

const StyledSection = styled(Box)<{ backgroundGradientColors?: [string, string] }>(
    ({ backgroundGradientColors }) => css`
        position: relative;
        ${backgroundGradientColors
            ? `background: linear-gradient(180deg, ${backgroundGradientColors[0]} 0%, ${backgroundGradientColors[1]} 100%);`
            : ``}
    `
);

const PageSection = ({
    id,
    children,
    pageName,
    backgroundGradientColors,
    onEnter,
    ...props
}: PageSectionProps) => {
    let scrollableAncestor: (Window & typeof globalThis) | null = null;
    if (typeof window !== 'undefined') {
        scrollableAncestor = window;
    }

    return (
        <Waypoint
            scrollableAncestor={scrollableAncestor}
            topOffset={'70%'}
            bottomOffset={'30%'}
            onEnter={() => {
                onEnter && onEnter(id);
                trackEvent('Page Scrolled', {
                    page_name: pageName,
                    to_element: id,
                });
            }}
            fireOnRapidScroll={false}
        >
            <StyledSection id={id} backgroundGradientColors={backgroundGradientColors} {...props}>
                {children}
            </StyledSection>
        </Waypoint>
    );
};

export default PageSection;
